<script setup>
import useCustomFormTable from "./hooks/useCustomFormTable";
import { FORM_TYPE, FORM_STATUS } from "@/constants";
import adjust from "./adjust.vue";
import { onMounted } from "vue";

const {
  searchRef,
  adjustRef,
  searchData,
  pages,
  tableLoading,
  tableData,
  columns,
  queryTable,
  handleReset,
  handleAdjust,
  handleDelete,
  handleDesign,
} = useCustomFormTable();

onMounted(() => {
  queryTable();
});
</script>

<template>
  <zh-table-page v-bind="{ title: '自定义表单' }">
    <template #header-btn>
      <el-button type="primary" icon="Plus" @click="handleAdjust(null, 'add')"
        >新增</el-button
      >
    </template>
    <template #search>
      <el-form :model="searchData" ref="searchRef" :inline="true">
        <el-form-item prop="formKey">
          <el-input v-model="searchData.formKey" placeholder="表单key" />
        </el-form-item>
        <el-form-item prop="formName">
          <el-input v-model="searchData.formName" placeholder="表单名" />
        </el-form-item>
        <el-form-item prop="formType">
          <el-select
            v-model="searchData.formType"
            placeholder="表单类型"
            style="width: 100%"
          >
            <el-option
              v-for="item in FORM_TYPE"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="state">
          <el-select
            v-model="searchData.state"
            placeholder="表单状态"
            style="width: 100%"
          >
            <el-option
              v-for="item in FORM_STATUS"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="Search" @click="queryTable()"
            >搜索</el-button
          >
          <el-button icon="Refresh" @click="handleReset()">重置</el-button>
        </el-form-item>
      </el-form>
    </template>
    <template #table>
      <el-table
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        v-loading="tableLoading"
        :data="tableData"
      >
        <template v-for="item in columns" :key="item.prop">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :min-width="120"
            show-overflow-tooltip
          >
            <template #default="{ row }">
              <span v-if="item.prop == 'formType'">
                {{ row[item.prop]?.desc }}
              </span>
              <span v-else-if="item.prop == 'state'">
                <el-tag :type="row[item.prop]?.value == '1' ? '' : 'danger'">{{
                  row[item.prop]?.desc
                }}</el-tag>
              </span>
              <span v-else>{{ row[item.prop] || "-" }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作" width="200">
          <template #default="{ row }">
            <el-button type="primary" link @click="handleDesign(row, 'design')"
              >设计</el-button
            >
            <el-button type="primary" link @click="handleDesign(row, 'review')"
              >预览</el-button
            >
            <el-button type="primary" link @click="handleAdjust(row, 'edit')"
              >编辑</el-button
            >
            <el-button type="danger" link @click="handleDelete(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :total="pages.total"
        v-model:current-page="pages.page"
        @update:current-page="queryTable"
        layout="->, prev, pager, next"
      />
    </template>
  </zh-table-page>
  <!-- 新增编制弹窗 -->
  <adjust ref="adjustRef" @after-save="queryTable" />
</template>

<style scoped>
.dropdown-link {
  cursor: pointer;
  color: #409eff;
}
</style>
